/**
 * ╔══════════════════════════════════════════════════════════════════╗
 * ║  HERCULES — Category Grid JS                                    ║
 * ║  Dosya: assets/hercules-category-grid.js                        ║
 * ║                                                                  ║
 * ║  Görevler:                                                       ║
 * ║  1. Scroll reveal (IntersectionObserver) — section + kartlar    ║
 * ║  2. Schema renk & boyut değerlerini CSS değişkenine aktar       ║
 * ║  3. Grid yüksekliğini schema değeriyle uygula                   ║
 * ║  4. Shopify Theme Editor live reload desteği                    ║
 * ╚══════════════════════════════════════════════════════════════════╝
 */

(function () {
  "use strict";

  /* ─── Sabitler ─────────────────────────────────────────────────── */
  var SELECTOR_SECTION = ".hcg-section";
  var SELECTOR_WRAPPER = ".hcg-wrapper";
  var SELECTOR_GRID = ".hcg-grid";
  var CLASS_REVEAL = "hcg-reveal";
  var CLASS_VISIBLE = "hcg-reveal--visible";
  var CLASS_DISABLED = "hcg-reveal--disabled";
  var THRESHOLD = 0.1;

  /* ─── Yardımcı: data attribute ──────────────────────────────────── */
  function attr(el, key, fallback) {
    var val = el.getAttribute("data-hcg-" + key);
    return val !== null ? val : fallback !== undefined ? fallback : null;
  }

  /* ─── CSS değişkenlerini uygula ──────────────────────────────────── */
  function applyColors(section) {
    var accent = attr(section, "accent", null);
    var bg = attr(section, "bg", null);
    var title = attr(section, "title", null);

    if (accent) section.style.setProperty("--hcg-section-accent", accent);
    if (bg) section.style.setProperty("--hcg-section-bg", bg);
    if (title) section.style.setProperty("--hcg-section-title", title);
  }

  /* ─── Padding & boyutları uygula ────────────────────────────────── */
  function applyLayout(wrapper, section) {
    var pt = attr(wrapper, "pt", null);
    var pb = attr(wrapper, "pb", null);
    var px = attr(wrapper, "px", null);
    var h = attr(section, "height", null);

    if (pt) section.style.setProperty("--hcg-pt", pt + "px");
    if (pb) section.style.setProperty("--hcg-pb", pb + "px");
    if (px) section.style.setProperty("--hcg-px", px + "px");

    if (h) {
      var grid = section.querySelector(SELECTOR_GRID);
      if (grid) grid.style.setProperty("--hcg-height", h + "px");
    }
  }

  /* ─── Scroll reveal ──────────────────────────────────────────────── */
  function setupReveal(section) {
    var enabled = attr(section, "reveal", "true");
    var prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    if (enabled === "false" || prefersReduced) {
      section.classList.remove(CLASS_REVEAL);
      section.classList.add(CLASS_DISABLED);
      return;
    }

    if (!("IntersectionObserver" in window)) {
      section.classList.add(CLASS_VISIBLE);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add(CLASS_VISIBLE);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: THRESHOLD },
    );

    observer.observe(section);
  }

  /* ─── Tek section başlat ─────────────────────────────────────────── */
  function initSection(section) {
    var wrapper = section.closest(SELECTOR_WRAPPER) || section.parentElement;

    applyColors(section);
    if (wrapper) applyLayout(wrapper, section);
    setupReveal(section);
  }

  /* ─── Tüm section'ları başlat ────────────────────────────────────── */
  function init() {
    document.querySelectorAll(SELECTOR_SECTION).forEach(initSection);
  }

  /* ─── Shopify Theme Editor ───────────────────────────────────────── */
  document.addEventListener("shopify:section:load", function (e) {
    var section = e.target && e.target.querySelector(SELECTOR_SECTION);
    if (!section) return;
    section.classList.remove(CLASS_VISIBLE, CLASS_DISABLED);
    initSection(section);
  });

  document.addEventListener("shopify:section:select", function (e) {
    var section = e.target && e.target.querySelector(SELECTOR_SECTION);
    if (section) section.classList.add(CLASS_VISIBLE);
  });

  document.addEventListener("shopify:section:deselect", function (e) {
    var section = e.target && e.target.querySelector(SELECTOR_SECTION);
    if (section) section.classList.remove(CLASS_VISIBLE);
  });

  /* ─── Başlat ─────────────────────────────────────────────────────── */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
